export function fullName(user) {
  if (!user) {
    return '';
  }
  return user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim();
}
